/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaHomeLineGraph: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="homeLineGraph" viewBox="0 0 16 16">
      <path
        d="M1.59065 5.47416L7.59065 0.807492C7.83131 0.620159 8.16865 0.620159 8.40931 0.807492L14.4093 5.47416C14.572 5.60016 14.6666 5.79483 14.6666 6.00016V13.3335C14.6666 14.4382 13.7713 15.3335 12.6666 15.3335H3.33331C2.22865 15.3335 1.33331 14.4382 1.33331 13.3335V6.00016C1.33331 5.79416 1.42798 5.60016 1.59065 5.47416ZM2.66665 6.32616V13.3335C2.66665 13.7015 2.96531 14.0002 3.33331 14.0002H12.6666C13.0346 14.0002 13.3333 13.7015 13.3333 13.3335V6.32616L7.99998 2.17816L2.66665 6.32616ZM4.30398 11.8722C4.00265 12.0842 3.58665 12.0115 3.37531 11.7102C3.16398 11.4088 3.23598 10.9928 3.53731 10.7815L6.31065 8.83216C6.51131 8.69083 6.77398 8.67149 6.99331 8.78216L8.85331 9.71683L11.646 6.86749C11.904 6.60483 12.326 6.60016 12.5886 6.85816C12.8513 7.11616 12.856 7.53816 12.598 7.80083L9.46465 10.9975C9.26198 11.2048 8.94798 11.2568 8.68931 11.1268L6.75065 10.1528L4.30331 11.8728L4.30398 11.8722Z"
        fill="#4D7080"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaHomeLineGraph)
